module.exports = __webpack_public_path__ + "media/PAG76-04.150b0a8b.mp3";